import { LANGUAGES } from '@savgroup-front-common/constants';
import { miniLanguageCode } from '@savgroup-front-common/core/helpers';

const ADYEN_DEFAULT_LOCALE = 'en-US';

const ADYEN_LOCALE_BY_LANGUAGE: Partial<Record<LANGUAGES, string>> = {
  [LANGUAGES.FR]: 'fr-FR',
  [LANGUAGES.EN]: 'en-US',
  [LANGUAGES.DE]: 'de-DE',
  [LANGUAGES.ES]: 'es-ES',
  [LANGUAGES.IT]: 'it-IT',
  [LANGUAGES.PT]: 'pt-PT',
  [LANGUAGES.NL]: 'nl-NL',
  [LANGUAGES.PL]: 'pl-PL',
  [LANGUAGES.SV]: 'sv-SE',
  [LANGUAGES.FI]: 'fi-FI',
  [LANGUAGES.NO]: 'no-NO',
  [LANGUAGES.DA]: 'da-DK',
  [LANGUAGES.CS]: 'cs-CZ',
  [LANGUAGES.HU]: 'hu-HU',
  [LANGUAGES.RO]: 'ro-RO',
  [LANGUAGES.EL]: 'el-GR',
  [LANGUAGES.BG]: 'bg-BG',
};

export const adaptLanguageToAdyenLocale = ({
  language,
}: {
  language: string;
}): string => {
  return (
    ADYEN_LOCALE_BY_LANGUAGE[miniLanguageCode(language)] ?? ADYEN_DEFAULT_LOCALE
  );
};
